import { useQuery, useQueryClient } from 'react-query';
import api from 'services';
import type { InflowOutflowByMonthResponse } from 'services/requests';
import type { ApiError } from 'services/api.errors';
import { useQueryPage } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import type { AxiosError } from 'axios';

export const useGetEtzProfileInflowOutflowByMonth = () => {
  const queryClient = useQueryClient();
  const { size, page } = useQueryPage();

  const params = {
    page,
    size,
  };

  const queryKey = [QueryKeys.etzProfileInflowOutflowByMonth, page, size];

  const queryFn = async () => {
    const { data } = await api.getEtzProfileInflowOutflowByMonth(params);
    return data;
  };

  return useQuery<InflowOutflowByMonthResponse, AxiosError<ApiError>>(queryKey, queryFn, {
    initialData() {
      return queryClient.getQueryData<InflowOutflowByMonthResponse>(queryKey);
    },
  });
};
